import React, { ReactNode } from 'react';
import styled from 'styled-components';
import StyledProps from '../../../../common/theme/AppThemeInterface';

export interface ChartCustomTooltipHeaderProps {
  children: ReactNode | ReactNode[];
}

const ChartCustomTooltipHeader = (props: ChartCustomTooltipHeaderProps) => {
  const { children } = props;
  return <StyledTooltipHeader>{children}</StyledTooltipHeader>;
};

export default ChartCustomTooltipHeader;

const StyledTooltipHeader = styled.div`
  background-color: #000000;
  padding: 17px 15px 18px;
  box-sizing: border-box;
  border-radius: 8px 8px 0 0;
  font-size: 12px;
  line-height: 18px;
  font-weight: normal;
  color: ${({ theme }: StyledProps) => theme.primaryTextColor};
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
`;
